export default {
  id: "starter",
  name: "starter",
  grid: [{
    "x": 0,
    "y": 0,
    "w": 4,
    "h": 4,
    "minW": 2,
    "minH": 1,
    "id": "4d304ce7-dba9-4dfb-b291-928e450a878b",
    "content": "4 x 4",
    "name": null,
    "type": null,
    "pos": 1,
    "data": null
  }, {
    "x": 4,
    "y": 0,
    "w": 4,
    "h": 4,
    "minW": 2,
    "minH": 1,
    "id": "a0973775-462f-4ee1-b544-3846373db9a5",
    "content": "4 x 4",
    "name": null,
    "type": null,
    "pos": 2,
    "data": null
  }, {
    "x": 8,
    "y": 0,
    "w": 4,
    "h": 8,
    "minW": 2,
    "minH": 1,
    "id": "b796935c-0e11-4a7d-82ee-bea56b167696",
    "content": "4 x 8",
    "name": null,
    "type": null,
    "pos": 3,
    "data": null
  }, {
    "x": 0,
    "y": 4,
    "w": 4,
    "h": 4,
    "minW": 2,
    "minH": 1,
    "id": "df63a5da-cc2e-4147-b528-6eda57269fe7",
    "content": "4 x 4",
    "name": null,
    "type": null,
    "pos": 4,
    "data": null
  }, {
    "x": 4,
    "y": 4,
    "w": 4,
    "h": 4,
    "minW": 2,
    "minH": 1,
    "id": "f981c6b3-587e-44ae-b2ae-7e2bb3641561",
    "content": "4 x 4",
    "name": null,
    "type": null,
    "pos": 5,
    "data": null
  }]
};
